export default "__VITE_ASSET__debd76ab__"